import React, { useState } from "react";
import "../styles/styles.css";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";

const Login = () => {
  const navigate = useNavigate();

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("MOBILE"); // MOBILE | OTP
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // -------------------------
  // STEP 1: SEND OTP
  // -------------------------
  const handleSendOtp = async () => {
    setError("");
    setLoading(true);

    try {
      const res = await apiClient.post("/auth/login", { mobile });

      if (res.data.code === "OTP_SENT") {
        setStep("OTP");
      } else {
        setError("Unable to send OTP");
      }
    } catch (e) {
      setError("Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  // -------------------------
  // STEP 2: VERIFY OTP
  // -------------------------
  const handleVerifyOtp = async () => {
    setError("");
    setLoading(true);

    try {
      const res = await apiClient.post("/auth/verify", { mobile, otp });

      if (res.data.code === "LOGIN_SUCCESS") {
        // check if role is ADMIN
        if (res.data.role !== "ADMIN") {
          setError("Access denied. Only admins can login.");
          return;
        }

        // store login info
        localStorage.setItem("loggedIn", "true");
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("userId", res.data.userId);
        localStorage.setItem("role", res.data.role);

        navigate("/dashboard");
      } else {
        setError("Invalid OTP");
      }
    } catch (e) {
      setError("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="login-card porter-theme">
        <h1 className="app-name">Zarkit</h1>
        <p className="subtitle">Admin Portal</p>

        {/* MOBILE INPUT */}
        <div className="input-group">
          <label>Phone Number</label>
          <input
            placeholder="Phone Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            disabled={step === "OTP"}
          />
        </div>

        {/* OTP INPUT (ONLY AFTER SEND OTP) */}
        {step === "OTP" && (
          <div className="input-group">
            <label>OTP</label>
            <input
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </div>
        )}

        {/* ERROR */}
        {error && <p className="error-text">{error}</p>}

        {/* BUTTON */}
        {step === "MOBILE" ? (
          <button
            className="btn-primary"
            onClick={handleSendOtp}
            disabled={loading}
          >
            {loading ? "Sending OTP..." : "LOGIN"}
          </button>
        ) : (
          <button
            className="btn-primary"
            onClick={handleVerifyOtp}
            disabled={loading}
          >
            {loading ? "Verifying..." : "VERIFY OTP"}
          </button>
        )}

        <p className="footer-text">
          New to Zarkit?
          <span className="link-text"> Create account</span>
        </p>
      </div>
    </div>
  );
};

export default Login;
